import { render, staticRenderFns } from "./studentUploadInfo.vue?vue&type=template&id=320fd70a&scoped=true&"
import script from "./studentUploadInfo.vue?vue&type=script&lang=ts&"
export * from "./studentUploadInfo.vue?vue&type=script&lang=ts&"
import style0 from "./studentUploadInfo.vue?vue&type=style&index=0&id=320fd70a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320fd70a",
  null
  
)

export default component.exports